module.exports = __webpack_public_path__ + "img/move21.cf2857ee.jpg";